import { get } from './agent';

const stripe = {
  public: {
    getCountries: () => get('stripe/countries'),
  },
};

export default stripe;
